module.exports = __webpack_public_path__ + "img/jobs_hover.d2ad41a3.svg";